import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button, FontWeights, units } from '@calm-web/design-system';

export const Container = styled.div``;

export const SubmitButton = styled(Button).attrs({
	textColor: 'white',
	backgroundColor: 'gradientCalmBrand',
	fullWidth: true,
	fontWeight: FontWeights.Demi,
	type: 'submit',
})`
	margin-bottom: ${units(4)};
`;

export const Form = styled.form``;

export const FormContainer = styled.div`
	background-color: ${palette('white')};
	border-radius: ${units(2)};
	padding: ${units(3)};
	margin-bottom: ${units(3)};
`;
